import { AddHomeOutlined, DashboardOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import ComprehensiveFooter from '../../MicrospecDynamicUI/Pages/SectionsMapper/Footer/ComprehensiveFooter';
import ModernNavbar from '../../MicrospecDynamicUI/Pages/SectionsMapper/Navbar/ModernNavbar';

const navbarSpec = {
    backgroundColor: 'rgba(255, 255, 255, 0.97)',
    textColor: '#333',
    height: '70px',
    transparent: false,
    blur: true,
    shadow: true,
    sticky: true,
    showLanguagesMenu: false,
    showSearch: false,
    showNotifications: false,
    showProfile: true,
    brandColor: '#046878',
    menuItems: [
        { label: 'الرئيسية', href: '/' },
    ],
    menuItemsWhenUserAuthenticated: [
        {
            label: { localizationObject: { type: 'Literal', text: 'لوحة التحكم' } },
            icon: <DashboardOutlined fontSize="small" />,
            onClick: () => { window.location.href = '/owners/dashboard'; },
        },
        {
            label: { localizationObject: { type: 'Literal', text: 'أضف عقارك' } },
            icon: <AddHomeOutlined fontSize="small" />,
            onClick: () => { window.location.href = '/owners/properties/add'; },
        },
    ],
    menuItemsWhenUserUnauthenticated: [
        {
            label: { localizationObject: { type: 'Literal', text: 'أضف عقارك' } },
            icon: <AddHomeOutlined fontSize="small" />,
            onClick: () => { window.location.href = '/owners/properties/add'; },
        },
    ],
};

const footerSpec = {
    backgroundColor: '#1a1a2e',
    textColor: '#ffffff',
    accentColor: '#046878',
    companyDescription: 'منصة عقاركو - وجهتك الأولى للبحث عن العقارات المميزة في المنطقة. نوفر لك أفضل الخيارات العقارية بأسعار تنافسية.',
    contactInfo: {
        email: 'info@akarko.com',
        // phone: '+966 50 000 0000',
        // address: '',
    },
    navigationLinks: [
        {
            title: 'روابط سريعة',
            links: [
                { label: 'الرئيسية', href: '/' },
                { label: 'سياسة الخصوصية', href: '/privacy' },
                { label: 'الشروط والأحكام', href: '/terms' },
            ],
        },
    ],
    socialMedia: {
        facebook: null,
        twitter: null,
        instagram: null,
        linkedin: null,
        youtube: null,
    },
};

const PagesLayout = ({ children, showFooter = true }) => {
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <ModernNavbar spec={navbarSpec} />
            <Box sx={{ flex: 1 }}>
                {children}
            </Box>
            {showFooter && <ComprehensiveFooter spec={footerSpec} />}
        </Box>
    );
};

export default PagesLayout;
